import Vue from 'vue'
import VueI18n from 'vue-i18n'
 

Vue.use(VueI18n)

let  defaultLang = document.documentElement.lang.substr(0, 2) || 'ar'

var urlSearchParams = new URLSearchParams(window.location.search)

var params = Object.fromEntries(urlSearchParams.entries())

if (params && params['lang']) {
    defaultLang = params['lang'] 
  } 

// console.log('lang', lang)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  if (localStorage.getItem('lang') == null) {
    localStorage.setItem('lang', 'ar')
    localStorage.setItem('dir', 'rtl')
  }
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const dictionary = {}
const messages = loadLocaleMessages()
// for (const key in messages) {
//   // console.log("key",  messages[key]);
//   const outt = Object.assign(messages[key], LocalesTrans[key])
//   messages[key] = outt
// }
const i18n = new VueI18n({
  locale: defaultLang,
  fallbackLocale:  defaultLang,
  messages,
})



export async function changeLang(locale) {
  // const current = i18n.global.locale

  // console.log('current', current)
  if (i18n.mode === "legacy") {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }


  defaultLang = locale
  
  Vue.nextTick(() => {

      if (i18n.mode === "legacy") {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }


  defaultLang = locale

    
    try {
 
  let dirction=locale=='ar'?'rtl':'ltr'

    document.querySelector("html").setAttribute("lang", locale)
    document.querySelector("html").setAttribute("dir", dirction)
  } catch (e) {
    console.warn('Load language error', e)
  }
  
  });
  

 
}


export async function hanldeLang() {
var urlSearchParams = new URLSearchParams(window.location.search)

var params = Object.fromEntries(urlSearchParams.entries())

if (params && params['lang'] && ['ar','en','cn'].includes(params['lang'])) {
  defaultLang = params['lang'] 
   changeLang(params['lang'])
  } 

}

export default  i18n
